export default __webpack_public_path__ + "static/media/hands_together.185d91a1.png";